{"NODE_ENV":"production","RAILS_ENV":"production","TUNAG_API_BASE_URL":"https://tunag.jp/","EDUCATION_BASE_URL":"https://education.tunag.jp/"}